import { getActionTypes } from '../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('vendorManagement')([
  'SET_LOADER',
  'LOAD_VENDORS',
  'UPSERT_VENDOR',
  'DELETE_VENDOR',
  'SET_FORM_LOADER',
]);

export function loadVendor(vendors) {
  return { type: types.LOAD_VENDORS, vendors };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function setFormLoader(loader) {
  return { type: types.SET_FORM_LOADER, loader };
}

export function upsertVendor(vendor) {
  return { type: types.UPSERT_VENDOR, vendor };
}

export function deleteVendor(vendor) {
  return { type: types.DELETE_VENDOR, vendorId: vendor.id };
}

export default function vendorReducer(
  state = { isVendorPageLoading: true, vendors: [], isVendorFormLoading: false },
  action
) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isVendorPageLoading: action.loader };
    }
    case types.SET_FORM_LOADER: {
      return { ...state, isVendorFormLoading: action.loader };
    }
    case types.LOAD_VENDORS: {
      return { ...state, vendors: action.vendors };
    }
    case types.DELETE_VENDOR: {
      return {
        ...state,
        vendors: state.vendors.filter(({ id: vendorId }) => vendorId !== action.vendorId),
      };
    }
    case types.UPSERT_VENDOR: {
      const { vendor } = action;
      return {
        ...state,
        vendors: [...state.vendors.filter(({ id: vendorId }) => vendorId !== vendor.id), vendor],
      };
    }
    default:
      return state;
  }
}
